import api from './api';

export const getEmployees = (params) => api.get('/v1/employees', { params });
export const getEmployee = (id) => api.get(`/v1/employees/${id}`);
export const createEmployee = (data) => api.post('/v1/employees', data);
export const updateEmployee = (id, data) => api.put(`/v1/employees/${id}`, data);
// İşten çıkarma — eski deleteEmployee/bulkDeleteEmployees çiftinin YERİNE. Tekil ve
// toplu aynı uçtan geçer; çıkış tarihi ve nedeni artık işlemin ayrılmaz parçası
// (bkz. EmployeeTerminateRequest). OD modülü açık kiracıda backend 409 döner —
// orada çıkış ayrılış sürecinin işidir.
export const terminateEmployees = ({ ids, terminationDate, exitReasonCode }) =>
  api.post('/v1/employees/terminate', { ids, terminationDate, exitReasonCode });

// Hatalı kayıt temizliği (hiç çalışan olmamış satır) — işten çıkarmadan AYRI iş.
// `employee.hasHistory` 409'unun toast'ı BİLEREK susturulur: o yanıtın gövdesinde
// hangi izlerin bulunduğu (kategori -> sayı) geliyor ve ekran bunu tek satırlık bir
// hata yerine dökümlü bir diyalogla gösteriyor. Diğer tüm hatalar interceptor'a kalır.
export const deleteEmployeeRecord = (id) =>
  api.post(`/v1/employees/${id}/delete-record`, null, {
    skipErrorToast: ['employee.hasHistory'],
  });
export const getEmployeePersonnel = (id) => api.get(`/v1/employees/${id}/personnel`);
export const getEmployeeCareerHistory = (id) => api.get(`/v1/employees/${id}/career-history`);
export const getPersonalInformation = (userId) => api.get(`/v1/personal-information/${userId}`);
export const updatePersonalInformation = (recordId, data) => api.put(`/v1/personal-information/${recordId}`, data);
export const getCertificationsByUser = (userId, params) => api.get(`/v1/certifications/user/${userId}`, { params });
